import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../../../common/common.model';

export interface ExtAreaItem {
    tenantId: number;
    areaId: number;
    areaDefaultInitials: string;
    areaDefaultShortName: string;
    areaDefaultName: string;
    clientTranslationId: number;
    enabled: boolean;
    createdByUserId: number;
    createdOn: string;
    lastUpdatedByUserId: number;
    lastUpdatedOn: string;
    languageID: number;
}

export interface AreaItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
}

export class AreaItemModelTransformer
    implements ModelTransformer<AreaItem, ExtAreaItem>
{
    transform(model: ExtAreaItem): AreaItem {
        return {
            id: model.areaId,
            initials: model.areaDefaultInitials,
            shortName: model.areaDefaultShortName,
            name: model.areaDefaultName,
        };
    }
}

export class AreaItemModelSetTransformer extends ModelSetTransformer<
    AreaItem,
    ExtAreaItem
> {
    protected newTransformer(): ModelTransformer<AreaItem, ExtAreaItem> {
        return new AreaItemModelTransformer();
    }
}
